import React, { useState, useEffect } from "react";
import "./index.less";
import { Tabs, Space } from "antd";
import Home from "./home";
import Mxsj from "./mxsj";
import Mxgl from "./mxgl";
import Mxbs from "./mxbs";
import { isMobile } from "@/utils/public";
import axios from "axios";
import API from "@/api";

function Mxgc(props) {
  const { activeTab, mxglActivetab } = props;
  const isMob = isMobile();
  const [tab, setTab] = useState(activeTab);

  const [userInfo, setUserInfo] = useState({});
  const [spinning, setSpinning] = useState(true);
  const [types, setTypes] = useState([]);
  const [dataTypes, setDataTypes] = useState([]);
  const [models, setModels] = useState([]);
  const [tokens, setTokens] = useState([]);
  const tabs = [
    {
      label: "模型广场",
      key: "home",
      // children: <Home />
    },
    {
      label: "模型管理",
      key: "mxgl",
    },
    {
      label: "模型上架",
      key: "mxsj",
    },
    {
      label: "模型部署",
      key: "mxbs",
    },
  ];

  const changTab = () => {
    setTab("mxgl");
  };

  const getUserInfo = () => {
    return axios.get(API.getUserInfo);
  };

  const getModelType = () => {
    return axios.get(API.getModelType);
  };

  const getModelSelectData = () => {
    return axios.get(API.getModelSelectData);
  };

  const getTokenSelectData = () => {
    return axios.get(API.getTokenSelectData);
  };

  useEffect(() => {
    axios
      .all([
        getUserInfo(),
        getModelType(),
        getModelSelectData(),
        getTokenSelectData(),
      ])
      .then(
        axios.spread((res, res1, res2, res3) => {
          const data = res?.data?.result?.data || {};
          const data1 = res1?.data?.result?.data || {};
          const data2 = res2?.data?.result?.data || {};
          const data3 = res3?.data?.result?.data || {};

          const arr = [];
          data1.map((item) => {
            arr.push({
              label: item.name,
              value: item.code,
            });
          });
          setUserInfo(data);
          setModels(data2);
          setTokens(data3);
          setTypes([{ label: "全部", value: "all" }, ...arr]);
          setDataTypes(arr);
          setSpinning(false);
        })
      );
  }, []);

  return (
    <div className="zdSearch">
      <div className="mxgcHeader">
        <div
          className="title"
          style={{
            padding: isMob ? "0 24px 0 28px" : "0 35px",
          }}
        >
          模型服务
        </div>
        <div
          className="tabs"
          style={{
            paddingRight: isMob ? "unset" : "40px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
            }}
          >
            {tabs.map((item) => {
              return (
                <div
                  className="tabItem"
                  style={{
                    borderBottom:
                      tab === item.key ? "3px solid #1E5BCE" : "unset",
                    color: tab === item.key ? "#1E5BCE" : "unset",
                    cursor: "pointer",
                    padding: isMob ? "0 6px" : "0 10px",
                  }}
                  onClick={() => {
                    setTab(item.key);
                  }}
                >
                  {item.label}
                </div>
              );
            })}
          </div>
        </div>
      </div>
      {tab === "home" ? <Home changTab={changTab} /> : undefined}
      {tab === "mxsj" ? (
        <Mxsj types={dataTypes} userInfo={userInfo} />
      ) : undefined}
      {tab === "mxgl" ? (
        <Mxgl
          types={types}
          models={models}
          tokens={tokens}
          userInfo={userInfo}
          activeTab={mxglActivetab}
        />
      ) : undefined}
      {tab === "mxbs" ? <Mxbs types={dataTypes} userInfo={userInfo} /> : undefined}
    </div>
  );
}

export default Mxgc;
